import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

/**
 * TrendChart — 7-day stacked area chart for confirmed / RAC / waiting counts.
 * Wraps recharts AreaChart with the design's exact palette + gridline style.
 *
 * Props:
 *  - data:   [{day:"Mon", confirmed, rac, waiting}, ...]
 *  - height: chart height (default 170)
 */
const TrendChart = ({ data, height = 170 }) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart
        data={data}
        margin={{ top: 12, right: 8, bottom: 4, left: -16 }}
      >
        <defs>
          <linearGradient id="trendConfirmed" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#34d399" stopOpacity="0.34" />
            <stop offset="100%" stopColor="#34d399" stopOpacity="0.04" />
          </linearGradient>
          <linearGradient id="trendRac" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#fbbf24" stopOpacity="0.34" />
            <stop offset="100%" stopColor="#fbbf24" stopOpacity="0.04" />
          </linearGradient>
          <linearGradient id="trendWaiting" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#fb7185" stopOpacity="0.34" />
            <stop offset="100%" stopColor="#fb7185" stopOpacity="0.04" />
          </linearGradient>
        </defs>
        <CartesianGrid
          stroke="#27272a"
          strokeDasharray="2 4"
          vertical={false}
        />
        <XAxis
          dataKey="day"
          stroke="#52525b"
          tick={{
            fill: "#71717a",
            fontSize: 10,
            fontFamily: "var(--font-mono, JetBrains Mono)",
          }}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          stroke="#52525b"
          tick={{
            fill: "#52525b",
            fontSize: 10,
            fontFamily: "var(--font-mono, JetBrains Mono)",
          }}
          tickLine={false}
          axisLine={false}
          width={32}
          allowDecimals={false}
        />
        <Tooltip
          contentStyle={{
            background: "rgba(9,9,11,.94)",
            border: "1px solid #27272a",
            borderRadius: 8,
            fontSize: 11,
            fontFamily: "var(--font-mono, JetBrains Mono)",
            color: "#e4e4e7",
          }}
          labelStyle={{ color: "#a1a1aa" }}
          cursor={{ stroke: "#3f3f46", strokeDasharray: "2 4" }}
        />
        <Area
          type="monotone"
          dataKey="waiting"
          stackId="1"
          stroke="#fb7185"
          strokeWidth={1.5}
          fill="url(#trendWaiting)"
        />
        <Area
          type="monotone"
          dataKey="rac"
          stackId="1"
          stroke="#fbbf24"
          strokeWidth={1.5}
          fill="url(#trendRac)"
        />
        <Area
          type="monotone"
          dataKey="confirmed"
          stackId="1"
          stroke="#34d399"
          strokeWidth={1.5}
          fill="url(#trendConfirmed)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default TrendChart;
